import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { compatWrapper, convertLegacyRouteRef } from '@backstage/core-compat-api';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { Content, ContentHeader, SupportButton } from '@backstage/core-components';
import {
  ExploreLayout,
  CatalogKindExploreContent,
  ToolExplorerContent,
  exploreRouteRef,
} from '@backstage-community/plugin-explore';
import { RiStackLine } from '@remixicon/react';
import { GroupsFitDiagram } from './GroupsFitDiagram';

// Domains e Tools ficam exatamente como o plugin original (CatalogKindExploreContent
// e ToolExplorerContent, ambos exportados publicamente pelo pacote); só o conteúdo de
// Groups troca pelo GroupsFitDiagram (ver comentário lá - fit="grow" em vez de
// "contain", que ampliava demais o desenho com poucos grupos).
function ExplorePageWithFitGroups() {
  const configApi = useApi(configApiRef);
  const organizationName = configApi.getOptionalString('organization.name') ?? 'Backstage';
  return (
    <ExploreLayout title={`Explore the ${organizationName} ecosystem`}>
      <ExploreLayout.Route path="domains" title="Domains">
        <CatalogKindExploreContent kind="domain" />
      </ExploreLayout.Route>
      <ExploreLayout.Route path="groups" title="Groups">
        <Content noPadding stretch>
          <ContentHeader title="Groups">
            <SupportButton>Explore your groups.</SupportButton>
          </ContentHeader>
          <GroupsFitDiagram />
        </Content>
      </ExploreLayout.Route>
      <ExploreLayout.Route path="tools" title="Tools">
        <ToolExplorerContent />
      </ExploreLayout.Route>
    </ExploreLayout>
  );
}

// Sobrescreve a página "/explore" inteira do plugin explore: mesmo padrão já usado em
// App.tsx (SignInPage) e em modules/techdocsProviderLink (read-docs) - pluginId tem que
// ser o dono original da extensão ('explore'), sem "name" (o original também não define
// um), senão o Backstage ignora e mantém a padrão.
const explorePageOverride = PageBlueprint.make({
  params: {
    path: '/explore',
    title: 'Explore',
    icon: <RiStackLine />,
    routeRef: convertLegacyRouteRef(exploreRouteRef),
    noHeader: true,
    loader: async () => compatWrapper(<ExplorePageWithFitGroups />),
  },
});

export const explorePageModule = createFrontendModule({
  pluginId: 'explore',
  extensions: [explorePageOverride],
});
